<script lang="ts">
  import type { RecommendationProduct } from "../../interfaces/RecommendationProduct";

  import { recommendation } from "../../stores/recommendation";

  import Card from "../Common/Card.svelte";
  import ProductSingleImage from "./ProductDetails/ProductSingleImage.svelte";
  import ProductVendor from "./ProductDetails/ProductVendor.svelte";
  import ProductName from "./ProductDetails/ProductName.svelte";
  import ProductOptions from "./ProductDetails/ProductOptions.svelte";
  import ProductPrice from "./ProductDetails/ProductPrice.svelte";
  import ProductActions from "./ProductDetails/ProductActions.svelte";
  import ProductExpertMessage from "./ProductDetails/ProductExpertMessage.svelte";
  import ProductInfoDialog from "./ProductDialog/ProductInfoDialog.svelte";
  import BundledProductList from "./BundledProduct/BundledProductList.svelte";

  export let product: RecommendationProduct;

  let productDescription: HTMLDivElement;
  let productDescriptionClientHeight: number;
  let productDescriptionLineHeight: number;
  let productDescriptionContainerClientHeight: number;
  let viewAllDetailsClientHeight: number;

  $: showViewAllDetailsButton =
    productDescriptionClientHeight > productDescriptionContainerClientHeight;

  $: {
    if (productDescription && productDescriptionClientHeight) {
      const productDescriptionLineHeightString = window.getComputedStyle(
        productDescription
      ).lineHeight;
      productDescriptionLineHeight = +productDescriptionLineHeightString.replace(
        "px",
        ""
      );
    }
  }

  $: calculatedHeight =
    showViewAllDetailsButton &&
    viewAllDetailsClientHeight &&
    productDescriptionLineHeight &&
    Math.trunc(
      (productDescriptionContainerClientHeight -
        viewAllDetailsClientHeight -
        8) /
        productDescriptionLineHeight
    ) * productDescriptionLineHeight;

  let viewMore = false;

  function handleViewMoreOnClick() {
    viewMore = true;
  }

  function handleProductInfoModalOnClose() {
    viewMore = false;
  }

  $: {
    if (product.scrollTo) {
      recommendation.scrollTo(product.id, false);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }
</script>

<Card class="product-card">
  {#if product.bundledProducts}
    <BundledProductList bundledProducts={product.bundledProducts} />
  {:else}
    <ProductSingleImage {product} />
  {/if}
  <div class="product-card-content">
    <ProductVendor {product} />
    <ProductName {product} />
    <ProductOptions {product} />
    <ProductPrice {product} />
    {#if product.description && product.showDescription}
      <div
        bind:clientHeight={productDescriptionContainerClientHeight}
        class="product-description-container"
      >
        <div
          class="product-description-inner-container"
          style={calculatedHeight ? `height:${calculatedHeight}px;` : ""}
        >
          <div
            bind:this={productDescription}
            bind:clientHeight={productDescriptionClientHeight}
            class="text product-description"
          >
            {@html product.description}
          </div>
        </div>
        {#if showViewAllDetailsButton}
          <button
            bind:clientHeight={viewAllDetailsClientHeight}
            on:click={handleViewMoreOnClick}
            class="view-all-details"
          >
            View All Details
          </button>
        {/if}
      </div>
    {/if}
    <ProductActions {product} />
  </div>
</Card>
<ProductExpertMessage {product} />
{#if viewMore}
  <ProductInfoDialog {product} on:close={handleProductInfoModalOnClose} />
{/if}

<style lang="scss">
  .product-description-container {
    flex: 1;
    overflow: hidden;

    .product-description-inner-container {
      overflow: hidden;
    }

    .view-all-details {
      text-transform: unset;
      background: none;
    }
  }
</style>
